import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, UIConstants } from '@streem/ui-react';
import { CallTools } from './tools/call_tools';
import { BookmarkButton } from './tools/bookmark_button';
import { GPSbutton } from './tools/gps_button';
import { CallTransferButton } from './tools/call_transfer';
import { useCenterToolbar } from '../../../hooks/use_center_toolbar';
export const CenterToolBar = ({ setShowArrow, remoteUserName, isTrayOpen, }) => {
    const { addBookmark, showGps, showCallTransferButton } = useCenterToolbar();
    const gpsButton = showGps ? _jsx(GPSbutton, { roundLeftEdgeYn: false, roundRightEdgeYn: true }) : undefined;
    const callTransferButton = showCallTransferButton ? (_jsx(CallTransferButton, { roundRightEdgeYn: !showGps, isTrayOpen: isTrayOpen })) : undefined;
    return (_jsxs(CenterToolbarWrapper, { children: [_jsx(BookmarkButton, { addBookmark: addBookmark, roundLeftEdgeYn: true, roundRightEdgeYn: false }), _jsx(CallTools, { isTrayOpen: isTrayOpen, remoteUserName: remoteUserName, setShowArrow: setShowArrow, roundLeftEdgeYn: false, roundRightEdgeYn: !showGps && !showCallTransferButton }), callTransferButton, gpsButton] }));
};
const CenterToolbarWrapper = styled.div(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    margin: `.5rem`,
    padding: '0',
    borderRadius: UIConstants.ROUNDED_BUTTON_BORDER_RADIUS,
    backgroundColor: theme.colors.white,
}));
//# sourceMappingURL=center_toolbar.js.map